import React, { useState, useEffect, useContext } from "react";
import logo from '../assets/images/Dadi-logo.svg';
import { Link, useLocation, useNavigate } from "react-router-dom";
import tmdbApi from "../api/tmdbApi";
import { contentContext } from "../context/contentContext";
const Header = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const currentPath = location.pathname;
    const [userId, setUserId] = useState(null)
    const [token, setToken] = useState(null)
    
    const [name, setName] = useState(null)
    const userType = localStorage.getItem("userType")
    const { userData, userDataLoading } = useContext(contentContext);
    const handleClick = (value, type) => {
        if (value === "logout") {
            localStorage.clear()
            navigate("/login")
        }
        else if (value === "login") {
            localStorage.removeItem("selectedPlan")
            localStorage.removeItem("moduleid");
             localStorage.removeItem("libraryId");

            navigate("/login")
        } else if (value === "signUp") {
              localStorage.removeItem("selectedPlan")
            localStorage.removeItem("moduleid");
            localStorage.removeItem("libraryId")
            localStorage.setItem('userType', type)
            navigate("/signup")
        }
    }
console.log("userDatatatatatatata",userData)
    // const handleLogout = async () => {
    //     localStorage.clear();
       
    //       signoutsession()
    //     navigate("/")
    //     window.location.reload()
    // }
 const handleLogout = (e) => {
        // debugger
        // GetTimeActivity();
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        localStorage.removeItem("email");
        
        localStorage.removeItem("moduleid");
        localStorage.removeItem("libraryId");
        localStorage.removeItem("ClientName");
        localStorage.removeItem("ClientType");
        localStorage.removeItem('subscriptionPlanId')
        signoutsession();
        navigate("/");


    }

const signoutsession = async () => {
        try {
            const response = await tmdbApi.SignOutUser({ emailId: userData.emailid });
            console.log(response);

        } catch {
            console.log("error");
        }
    }
    useEffect(() => {
        if (localStorage.getItem("token")) {
            setUserId(localStorage.getItem("userId"))
            setToken(localStorage.getItem("token"))
            // setName(localStorage.getItem("name"))
        }
        // else {
        //     navigate("/")
        // }

    }, [])
    const handleDashboardClick = (e) => {
         
        e.preventDefault();
        localStorage.removeItem("subscriptionPlanId");
        if (!token) {
            navigate("/");
        } else if (userType === "DOCTOR") {
            navigate("/cpc");
        } else {
            navigate("/dashboard");
        }
    };
    const handleProfile = (e) => {
        // GetTimeActivity();
        localStorage.removeItem("subscriptionPlanId");
        navigate("/profile");
    }
    return (
        <nav className="navbar navbar-expand-lg navbar-section">
            <div className="container d-flex align-items-center justify-content-between custom-header">
                {/* Logo Section */}
                <Link className="navbar-brand logo-section" to="/">
                    <img src={logo} alt="DADI Logo" width="250" className="brand_logo me-2" />
                </Link>

                {/* Signin / Profile Section */}
                <div className="signin-block d-flex align-items-center">
                    {!token ? (
                        <>
                            <button className="sign-in-btn me-2" onClick={() => handleClick("login", null)}>
                                <span className="material-symbols-outlined">person</span> Sign In
                            </button>
                            <div className="dropdown">
                                <button className="sign-in-btn active dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"  onClick={() => handleClick("signUp", "DOCTOR")}>
                                    Sign Up
                                </button>
                                {/* <ul className="dropdown-menu">
                                    <li>
                                        <a className="dropdown-item text-secondary text-center" onClick={() => handleClick("signUp", "CLINICIAN")}>
                                            Clinician
                                        </a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item text-secondary text-center" onClick={() => handleClick("signUp", "STUDENT")}>
                                            Student
                                        </a>
                                    </li>
                                </ul> */}
                            </div>
                        </>
                    ) : (
                        <div className="dropdown d-inline-block">
                            <div className="navbar-brand-box">
                                <button
                                    type="button"
                                    className="btn header-item waves-effect"
                                    id="page-header-user-dropdown"
                                    data-bs-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <span className="profile_pic">
                                        {userDataLoading
                                            ? <span className="spinner-border spinner-border-sm" style={{ width: '14px', height: '14px', borderWidth: '2px' }} role="status" />
                                            : userData?.name?.slice(0, 2)?.toUpperCase()
                                        }
                                    </span>
                                    <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                                </button>
                                <div className="dropdown-menu dropdown-menu-end login-header">
                                    <a className="dropdown-item text-secondary" onClick={handleProfile}>
                                        <i className="bx bx-user font-size-16 align-middle me-1"></i>
                                        <span>Profile</span>
                                    </a>
                                    <div className="dropdown-divider"></div>
                                    <a className="dropdown-item text-danger" onClick={handleLogout}>
                                        <i className="bx bx-power-off font-size-16 align-middle me-1"></i>
                                        <span>Logout</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Toggler for mobile */}
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* Navigation links */}
                <div className="collapse navbar-collapse nav-links-section justify-content-center" id="navbarNav">
                    <ul className="navbar-nav nav-menus-wrapper mx-auto">
                        {/* <li className="nav-item">
                            <Link
                                className={currentPath === "/" ? "nav-link active" : "nav-link"}
                                to={!token ? "/" : userType === "DOCTOR" ? "/cpc" : "/dashboard"}
                            >
                                {!token ? "Home" : "Dashboard"}
                            </Link>
                        </li> */}
                        <li className="nav-item">
                            <Link
                                to={!token ? "/" : userType === "DOCTOR" ? "/cpc" : "/dashboard"}
                                onClick={handleDashboardClick}
                                className={currentPath === "/" ? "nav-link active" : "nav-link"}
                            >
                                {!token ? "Home" : "Dashboard"}
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={currentPath === "/diagnostics" ? "nav-link active" : "nav-link"} to="/diagnostics">
                                Diagnostics
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link  onClick={() => localStorage.removeItem("moduleid")} className={  currentPath === "/learning" || currentPath === "/lecture-library" ||currentPath ==="/moduleslibrary" ? "nav-link active" : "nav-link"} to="/learning">
                                Learning Hub
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={currentPath === "/cpcregistration" ? "nav-link active" : "nav-link"} to="/cpcregistration">
                                CPC
                            </Link>
                        </li>
                        {/* <li className="nav-item">
                            <Link className={currentPath === "/moduleslibrary" ? "nav-link active" : "nav-link"} to="/moduleslibrary">
                                Modules Library
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={currentPath === "/lecturelibrary" ? "nav-link active" : "nav-link"} to="/lecturelibrary">
                                Lecture Library
                            </Link>
                        </li> */}
                        <li className="nav-item">
                            <Link className={currentPath === "/fellowship" ? "nav-link active" : "nav-link"}onClick={() => localStorage.removeItem("libraryId")} to="/fellowship">
                                Fellowship
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={currentPath === "/about" ? "nav-link active" : "nav-link"} to="/about">
                                About
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={currentPath === "/contact" ? "nav-link active" : "nav-link"} to="/contact">
                                Contact
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Header;